import { IP_BOARD_404_VIEW, IP_BOARD_FAILURE_VIEW } from '../../../../actions/work/index.tsx';
import type { Action } from '../../../../types.tsx';

// remove when cleaning up jpo-pb-add-experience-failure-tracker
export const isIpBoardFailedReducerOld = (state = false, action: Action): boolean => {
	if (action.type === IP_BOARD_404_VIEW) {
		return true;
	}

	return state;
};

export const isIpBoardFailedReducer = (
	state: number | null = null,
	action: Action,
): number | null => {
	if (action.type === IP_BOARD_FAILURE_VIEW) {
		return action.payload.statusCode;
	}

	return state;
};
